import { z } from 'zod';

export const DepositLimitTypeZod = z.enum(['rolling', 'calendar', 'lifetime']);
export type DepositLimitTypeType = z.TypeOf<typeof DepositLimitTypeZod>;

export const DepositLimitCalculationTypeZod = z.enum(['net', 'gross']);
export type DepositLimitCalculationTypeType = z.TypeOf<typeof DepositLimitCalculationTypeZod>;

export const DepositLimitConfigurationZod = z.object({
    type: DepositLimitTypeZod,
    calc: DepositLimitCalculationTypeZod,
    window: z.number(),
    threshold: z.number(),
});
export type DepositLimitConfigurationType = z.TypeOf<typeof DepositLimitConfigurationZod>;

export const SourceOfFundsConfigurationZod = z.object({
    globalLimit: DepositLimitConfigurationZod,
    freshCustomerSignupWindow: z.number(),
    freshCustomerLimit: DepositLimitConfigurationZod,
});
export type SourceOfFundsConfigurationType = z.TypeOf<typeof SourceOfFundsConfigurationZod>;

export const SofStatusZod = z.enum(['failed', 'requested', 'successful']);
export type SofStatusType = z.TypeOf<typeof SofStatusZod>;

export const SourceOfFundsCustomerStatusZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    status: SofStatusZod.optional(),
});
export type SourceOfFundsCustomerStatusType = z.TypeOf<typeof SourceOfFundsCustomerStatusZod>;

export const SourceOfFundsSetStatusPayloadZod = z.object({
    accountId: z.number(),
    status: SofStatusZod,
});
export type SourceOfFundsSetStatusPayloadType = z.TypeOf<typeof SourceOfFundsSetStatusPayloadZod>;
